import React from "react";
import Script from "next/script";
import settings, {
    DEFAULT_USER_CENTRICS_ID,
    SETTING_USER_CENTRICS_ID,
    SETTING_USER_CENTRICS_VERSION, SETTINGS_DISABLE_USER_CENTRICS_FOR_CURRENT_PAGE
} from "../../pages/config/settings";


interface Props {
    pageProps: any,
}

const UC_SCRIPT = "https://web.cmp.usercentrics.eu/ui/loader.js";

const isStudioPreview = () => {
    if (typeof window === 'undefined') return false;
    try {
        const url = new URL(window.location.href);
        const isEmbedded = !!window.location.ancestorOrigins?.[0]?.includes('studio.');
        const isPreviewPath = url.pathname === '/preview';
        return isEmbedded && isPreviewPath;
    } catch (e) {
        return false;
    }
};

const isE2eTest = () => {
    if (typeof window === 'undefined') return false;
    try {
        const url = window.location.href;
        return url && (url.startsWith("/e2etest") || (url.indexOf("e2etest=true") > -1));
    } catch (e) {
        return false;
    }
}

function Usercentrics({pageProps}: Props) {
    const ucVersion = settings(pageProps.CAEGlobalSettings, SETTING_USER_CENTRICS_VERSION);
    const ucId = settings(pageProps.CAEGlobalSettings, SETTING_USER_CENTRICS_ID, DEFAULT_USER_CENTRICS_ID);
    const isTurnOffUsercentrics = pageProps?.page?.marketingSettings?.[SETTINGS_DISABLE_USER_CENTRICS_FOR_CURRENT_PAGE] || isStudioPreview() || isE2eTest();

    const ucProperties: {
        id: string,
        "data-settings-id": string,
        src: string,
        "data-draft"?: string
    } = {
        id: "usercentrics-cmp",
        "data-settings-id": ucId,
        src: UC_SCRIPT
    };

    if (ucVersion === "preview") {
        ucProperties["data-draft"] = "true";
    }

    return !isTurnOffUsercentrics ? <Script {...ucProperties} async /> : null;
}

export default Usercentrics